<ng-container *ngIf="{
  config: config$ | async
} as resolved">
  <lib-block-title
    id="evcharge-config-title"
    [title]="labels.title">
  </lib-block-title>

  <p class="mt-3 mb-6 text-grey-400 text-normal-wrap tw-text-sm tw-font-normal">
    {{ labels.description }}
  </p>

  <ng-container *ngIf="resolved.config; else skeletonView">
    <!-- azzurro hub strategy for evcharge selected -->
    <section
      *ngIf="resolved.config.evchStrategy"
      class="ev-custom-section">
      <customer-title-content
        *ngIf="resolved.config.evchStrategy === AHevchStrategyEnum.fast"
        [title]="labels.selectedFastTitle"
        [content]="labels.selectedFastDescription">
      </customer-title-content>
      <customer-title-content
        *ngIf="resolved.config.evchStrategy === AHevchStrategyEnum.green"
        [title]="labels.selectedGreenTitle"
        [content]="labels.selectedGreenDescription">
      </customer-title-content>
    </section>
    <form
      [formGroup]="form"
      class="fx-row fx-wrap fx-gap-3">

      <!-- Main Control Section -->
      <section class="ev-custom-section evchCtrlEna">
        <customer-title-content [title]="labels.enableControl">
        </customer-title-content>
        <div class="fx-row fx-gap-3 fx-align-center">
          <mat-slide-toggle
            formControlName="evchCtrlEna"
            class="m-0 my-3">
          </mat-slide-toggle>
          <customer-title-content [content]="labels.enableControlDesc">
          </customer-title-content>
        </div>
      </section>

      <!-- Time Slot Section -->
      <section
        class="ev-custom-section"
        [ngClass]="{'disabled-section': !form.get('evchCtrlEna')?.value}">
        <customer-title-content
          [title]="labels.timeSectionTitle"
          [content]="labels.timeSectionDescription">
        </customer-title-content>

        <div class="fx-row fx-gap-3 fx-align-center mb-3">
          <mat-slide-toggle
            formControlName="evchTimeModeEna"
            class="m-0 my-3">
          </mat-slide-toggle>
          <customer-title-content [content]="labels.enableTimeMode">
          </customer-title-content>
        </div>

        <div
          class="fx-col fx-gap-3 mt-3"
          [ngClass]="{'disabled-section': !form.get('evchTimeModeEna')?.value || !form.get('evchCtrlEna')?.value}">
          <customer-title-content
            [title]="labels.timeStart"
            [content]="labels.timeStartDescription">
          </customer-title-content>
          <mat-form-field
            subscriptSizing="dynamic"
            class="custom-mat-form-field w-full custom-border-bottom">
            <input
              matInput
              type="time"
              formControlName="evchTimeStart"
              [placeholder]="labels.timeStartPlaceholder">
            <mat-error *ngIf="form.get('evchTimeStart')?.hasError('invalidTimeFormat')">
              {{ labels.timeFormatError }}
            </mat-error>
          </mat-form-field>

          <customer-title-content
            [title]="labels.timeStop"
            [content]="labels.timeStopDescription">
          </customer-title-content>
          <mat-form-field
            subscriptSizing="dynamic"
            class="custom-mat-form-field w-full custom-border-bottom">
            <input
              matInput
              type="time"
              formControlName="evchTimeStop"
              [placeholder]="labels.timeStopPlaceholder">
            <mat-error *ngIf="form.get('evchTimeStop')?.hasError('invalidTimeFormat')">
              {{ labels.timeFormatError }}
            </mat-error>
          </mat-form-field>
        </div>
      </section>

      <!-- Battery Protection Section -->
      <section
        class="ev-custom-section"
        [ngClass]="{'disabled-section': !form.get('evchCtrlEna')?.value}">
        <customer-title-content
          [title]="labels.batterySectionTitle"
          [content]="labels.batterySectionDescription">
        </customer-title-content>

        <div class="fx-row fx-gap-3 fx-align-center mb-3">
          <mat-slide-toggle
            formControlName="evchBatteryProtectEna"
            class="m-0 my-3">
          </mat-slide-toggle>
          <customer-title-content [content]="labels.enableBatteryProtect">
          </customer-title-content>
        </div>

        <div
          class="mt-3"
          [ngClass]="{'disabled-section': !form.get('evchBatteryProtectEna')?.value || !form.get('evchCtrlEna')?.value}">
          <customer-title-content
            [title]="labels.batterySOCLimit"
            [content]="labels.batterySOCLimitDescription">
          </customer-title-content>
          <mat-form-field
            subscriptSizing="dynamic"
            class="custom-mat-form-field w-full custom-border-bottom">
            <input
              matInput
              type="number"
              min="0"
              max="100"
              formControlName="evchBatterySOCLimit"
              [placeholder]="labels.batterySOCLimitPlaceholder">
            <mat-error *ngIf="form.get('evchBatterySOCLimit')?.hasError('min') || form.get('evchBatterySOCLimit')?.hasError('max')">
              {{ labels.batterySOCError }}
            </mat-error>
            <mat-error *ngIf="form.get('evchBatterySOCLimit')?.hasError('required')">
              {{ labels.batterySOCError }}
            </mat-error>
          </mat-form-field>
        </div>
      </section>

      <!-- Grid Power Limit Section -->
      <section
        class="ev-custom-section"
        [ngClass]="{'disabled-section': !form.get('evchCtrlEna')?.value}">
        <customer-title-content
          [title]="labels.powerSectionTitle"
          [content]="labels.powerSectionDescription">
        </customer-title-content>

        <div class="fx-row fx-gap-3 fx-align-center mb-3">
          <mat-slide-toggle
            formControlName="evchPwrImportLimit"
            class="m-0 my-3">
          </mat-slide-toggle>
          <customer-title-content [content]="labels.enablePowerImport">
          </customer-title-content>
        </div>

        <div
          class="mt-3"
          [ngClass]="{'disabled-section': !form.get('evchPwrImportLimit')?.value || !form.get('evchCtrlEna')?.value}">
          <customer-title-content
            [title]="labels.powerImportValue"
            [content]="labels.powerImportValueDescription">
          </customer-title-content>
          <mat-form-field
            subscriptSizing="dynamic"
            class="custom-mat-form-field w-full custom-border-bottom">
            <input
              matInput
              type="number"
              min="0"
              max="100"
              formControlName="evchPwrImportValue"
              [placeholder]="labels.powerImportValuePlaceholder">
            <mat-error *ngIf="form.get('evchPwrImportValue')?.hasError('min') || form.get('evchPwrImportValue')?.hasError('max')">
              {{ labels.powerImportError }}
            </mat-error>
            <mat-error *ngIf="form.get('evchPwrImportValue')?.hasError('required')">
              {{ labels.powerImportError }}
            </mat-error>
          </mat-form-field>
        </div>
      </section>

      <!-- Parallel Charging Section -->
      <section
        class="ev-custom-section evchParallelEna"
        [ngClass]="{'disabled-section': !form.get('evchCtrlEna')?.value}">
        <customer-title-content [title]="labels.enableParallel">
        </customer-title-content>
        <div class="fx-row fx-gap-3 fx-align-center">
          <mat-slide-toggle
            formControlName="evchParallelEna"
            class="m-0 my-3">
          </mat-slide-toggle>
          <customer-title-content [content]="labels.enableParallelDesc">
          </customer-title-content>
        </div>
      </section>

      <!-- Action Buttons -->
      <div class="fx-row fx-justify-between fx-gap-3 mt-6 ml-auto">
        <button
          class="custom-mat-button-secondary"
          mat-button
          type="button"
          (click)="onReset()">
          {{ labels.reset }}
        </button>
        <button
          class="custom-mat-button-primary"
          mat-button
          type="button"
          [disabled]="form.invalid"
          (click)="onSave()">
          {{ labels.save }}
        </button>
      </div>
    </form>
  </ng-container>
</ng-container>

<ng-template #skeletonView>
  <div class="fx-row fx-wrap fx-gap-3">
    <!-- Main Control Skeleton -->
    <ion-skeleton-text
      class="w-full h-20"
      style="border-radius: 4px;"
      [animated]="true">
    </ion-skeleton-text>

    <!-- Other Sections Skeleton -->
    <ion-skeleton-text
      *ngFor="let _ of [].constructor(3)"
      class="h-100"
      style="border-radius: 4px; flex-basis: 300px; flex-grow: 2;"
      [animated]="true">
    </ion-skeleton-text>

    <ion-skeleton-text
      class="w-full h-20"
      style="border-radius: 4px;"
      [animated]="true">
    </ion-skeleton-text>

    <!-- Action Buttons Skeleton -->
    <div class="fx-row fx-justify-end fx-align-center fx-gap-3 mt-6 w-full">
      <ion-skeleton-text
        class="w-40 h-20"
        style="border-radius: 4px;"
        [animated]="true">
      </ion-skeleton-text>
      <ion-skeleton-text
        class="w-40 h-20"
        style="border-radius: 4px;"
        [animated]="true">
      </ion-skeleton-text>
    </div>
  </div>
</ng-template>
